import React from "react"

import { buildQuery, useQuery } from "micro-graphql-react"

import WithLoadingIndicator from "components/WithLoadingIndicator"

import Form from "./Form"
import loadStudentQuery from "./loadStudentQuery"

const EditStudentForm = props => {
  const { id } = props
  const loadingState = useQuery(buildQuery(loadStudentQuery, { id }))

  const buildFormState = student => {
    const { grade, school, parent, organization, tags, ...studentFields } =
      student

    const normalizedGrade = grade
      ? {
          value: grade.id,
          label: grade.name,
        }
      : null

    const normalizedSchool = school
      ? {
          value: school.id,
          label: school.name,
        }
      : null

    const normalizedParent = parent
      ? {
          label: parent.fullName,
          value: parent.id,
        }
      : null

    const normalizedOrganization = organization
      ? {
          label: organization.name,
          value: organization.id,
        }
      : null

    const normalizedTags = tags.map(tag => ({ value: tag.id, label: tag.name }))

    return {
      id,
      grade: normalizedGrade,
      school: normalizedSchool,
      parent: normalizedParent,
      organization: normalizedOrganization,
      tags: normalizedTags,
      ...studentFields,
    }
  }

  const renderMessagingDisabledField = student => {
    return student.organization
      ? !student.organization.studentMessagingDisabled
      : true
  }

  return (
    <WithLoadingIndicator
      loadingState={loadingState}
      error="An error occurred while loading the requested student"
    >
      {({ data }) => (
        <Form
          formState={buildFormState(data.student)}
          renderMessagingDisabledField={renderMessagingDisabledField(
            data.student
          )}
        />
      )}
    </WithLoadingIndicator>
  )
}

export default EditStudentForm
